<template>
  <div class="topbar">
    <div class="brand-logo">
      <a href='/'><img src="@/assets/img/logo-white.png"></a>
    </div>
    <div class="top-right-button-wrap mobiletopbar">
      <ul>
        <li><router-link to='/Login'>{{ $t("Login.login")}}</router-link></li>
      </ul>
    </div>
    <div class="top-link top-link-el-dropdown">
      <el-dropdown trigger="click" @command="setLanguage">
        <span class="el-dropdown-link">
          {{currentlang}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="中文">中文</el-dropdown-item>
          <el-dropdown-item command="English">English</el-dropdown-item>
          <el-dropdown-item command="日本語">日本語</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    
  </div>  
</template>

<script>
export default {
  name: 'TopBarUnLogin',
  data(){
    return{
      currentlang: '中文',
      langs: ''
    }
  },
  mounted(){
    /**
     * 添加客服图标
     */
    // let pagehref = window.location.href
    // console.log(pagehref)
    // let kchatid = ''
    // if(pagehref.indexOf('?bd') != -1){
    //   kchatid = '1041131'
    // }else{
    //   kchatid = '1040403'
    // }
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = 'https://assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay()
    // script.id = 'kf5-provide-supportBox'
    // script.charset = "utf-8"
    // script.setAttribute('kchat-id', kchatid)
    // script.setAttribute('kf5-domain', 'simplybrand.kf5.com')
    // document.getElementsByTagName('head')[0].appendChild(script)

    if(window.localStorage.getItem('localeLanguage')){
      if(window.localStorage.getItem('localeLanguage') === 'zh'){
        this.currentlang = '中文'
      }
      if(window.localStorage.getItem('localeLanguage') === 'en'){
        this.currentlang = 'English'
      }
      if(window.localStorage.getItem('localeLanguage') === 'jp'){
        this.currentlang = '日本語'
      }
    }else{
      this.currentlang = '中文'
    }
    this.langs = window.localStorage.getItem('localeLanguage') ? window.localStorage.getItem('localeLanguage') === 'en'?'中':'EN' : 'EN'
  },
  methods:{
    changeLanguage : function() {
      if (this.$i18n.locale == 'en') {
        this.$i18n.locale = 'zh';
        this.langs = 'EN';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      } else {
        this.$i18n.locale = 'en';
        this.langs = '中';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
    },

    /**
     * 设置语言
     */
    setLanguage: function(command){
      if(command === '中文'){
        this.$i18n.locale = 'zh';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      }
      if(command === 'English'){
        this.$i18n.locale = 'en';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      }
      if(command === '日本語'){
        this.$i18n.locale = 'jp';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      }
      this.currentlang = command
    },
  }
}
</script>

<style scoped>
@media (max-width: 765px) {
  .mobiletopbar{
    display: none;
  }
}

</style>